const SidebarIcon = ({width='36px', height='36px', fill}) => {
    return (
        <svg x="0px" y="0px" width={width} height={height} viewBox="0 0 36 36" xmlSpace="preserve">
              <path d="M20,0H2.5C1.1,0,0,1.1,0,2.5v31c0,1.4,1.1,2.5,2.5,2.5h17.5c1.4,0,2.5-1.1,2.5-2.5V2.5c0-1.4-1.1-2.5-2.5-2.5Z" fill={fill}/>
              <path d="M33.5,0h-6.1c-1.4,0-2.5,1.1-2.5,2.5v31c0,1.4,1.1,2.5,2.5,2.5h6.1c1.4,0,2.5-1.1,2.5-2.5V2.5c0-1.4-1.1-2.5-2.5-2.5Z" fill={fill}/>
        </svg>
    )
};

export default SidebarIcon;